module.exports = __webpack_public_path__ + "img/male.8fe5240b.svg";